import React, { Component } from 'react';
import Navbar from '../Navbar'
import { Row, Col, Card, Button, CardHeader, CardBody, Table, Input } from 'reactstrap';
import Select from 'react-select';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';


const { proxy } = require('../../ip_api.config')

let columns = [
    {
        dataField: 'rowNo',
        text: 'No',
        headerStyle: (colum, colIndex) => {
            return { width: '7%', textAlign: 'center' };
        },
        style: { textAlign: 'center' }
    },
    {
        dataField: 'itemId',
        text: 'Item Number',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        }
    },
    {
        dataField: 'itemName',
        text: 'Product Name',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        }
    },
    {
        dataField: 'ibrand2Desc',
        text: 'IBrand 2',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        }
    },
    {
        dataField: 'ibrand3Desc',
        text: 'IBrand 3',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        }
    },
    {
        dataField: 'itemG1Desc',
        text: 'Item G1',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        }
    },
    {
        dataField: 'itemG3Desc',
        text: 'Item G3',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        }
    },
    {
        dataField: 'edit',
        text: '',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        },
        style: (colum, colIndex) => {
            return { textAlign: 'center' };
        },
        events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
                // stop event of row that still working 
                e.stopPropagation()
                let itemId = window.btoa(JSON.stringify(row.itemId))
                let id = window.btoa(JSON.stringify(row.id))
                window.open(`ManageProductImage?id=${id}&itemId=${itemId}`)
            },
        }
    },
    {
        dataField: 'link',
        text: '',
        headerStyle: (colum, colIndex) => {
            return { width: '10%', textAlign: 'center' };
        },
        style: (colum, colIndex) => {
            return { textAlign: 'center' };
        },
        events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
                // stop event of row that still working 
                e.stopPropagation()
                let itemId = window.btoa(JSON.stringify(row.itemId))
                let id = window.btoa(JSON.stringify(row.id))
                window.open(`ProductInfo?id=${id}&itemId=${itemId}`)
            },
        }
    }
];

class Film_DisplayTableProductImage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            filesDisplay: [],
            itemId: '',
            filterList: [
                {
                    displayName: 'Item Number',
                    name: 'itemId',
                    value: '',
                    inputType: 'text',
                    option: '',
                },
                {
                    displayName: 'Product Name',
                    name: 'itemDesc',
                    value: '',
                    inputType: 'text',
                    option: '',
                },
                {
                    displayName: 'IBrand 1',
                    name: 'iBrand1',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'IBrand 2',
                    name: 'iBrand2',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'IBrand 3',
                    name: 'iBrand3',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'Item G1',
                    name: 'itemG1',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
                {
                    displayName: 'Item G3',
                    name: 'itemG3',
                    value: '',
                    inputType: 'option',
                    option: [],
                },
            ],
            productData: [],
        }
    }

    componentDidMount() {
        this.get_G1Filter()
        this.getColumn()
        this.get_Ibrand1Filter()
    }

    getColumn = () => {
        let departmentRole = localStorage.getItem("DepartmentNo");
        if (departmentRole != 'D11') {
            columns.map((val, i) => {
                if (val.dataField === 'edit') {
                    columns.splice(i, 1)
                }
            })
        }
    }

    get_productData = (searchData) => {
        let url = proxy.server + '/flim/getProductData'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(searchData)
        })
            .then(response => response.json())
            .then((responseJson) => {
                switch (responseJson.status) {
                    case 200:
                        console.log("responseJson [get_productData]", responseJson)
                        let res = responseJson.result;
                        for (let key in res) {
                            res[key].edit = <Button color="warning" ><i class="fa fa-pencil" aria-hidden="true"></i> จัดการ</Button>
                            res[key].link = <Button color="primary" ><i class="fa fa-info-circle" aria-hidden="true"> รายละเอียด</i></Button>
                        }
                        this.setState({ productData: res })
                        break;
                    default: this.setState({ productData: [] })
                }
            })
    }

    get_G3Filter = (selected) => {
        let url = proxy.server + '/flim/getG3Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: selected })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemG3Id, label: val.itemG3Name })
                        })

                        filterList[6].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[6].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_Ibrand1Filter = () => {
        let url = proxy.server + '/flim/getIbrand1Filter'
        fetch(url, {
            method: "POST",
            headers: {
            },
            body: {}
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand1Id, label: val.iBrand1Name })
                        })
                        filterList[2].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[2].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_Ibrand2Filter = (selected) => {
        let url = proxy.server + '/flim/getIbrand2Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: selected })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand2Id, label: val.iBrand2Name })
                        })
                        filterList[3].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[3].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_Ibrand3Filter = (selected) => {
        let url = proxy.server + '/flim/getIbrand3Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: selected })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let filterList = this.state.filterList
                let arr = []

                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand3Id, label: val.iBrand3Name })
                        })
                        filterList[4].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[4].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_G1Filter = () => {
        let url = proxy.server + '/flim/getG1Filter'
        fetch(url, {
            method: "POST",
            headers: {
            },
            body: {}
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let arr = []
                let filterList = this.state.filterList
                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '----------ทั้งหมด---------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemG1Id, label: val.itemG1Name })
                        })
                        filterList[5].option = arr;
                        this.setState({ filterList: filterList })
                        break;
                    default:
                        filterList[5].option = arr;
                        this.setState({ filterList: filterList })
                }
            })
    }

    get_dataUploadedByItem = (selectedValue) => {
        let url = proxy.server + '/flim/getDataUploadedByItem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: selectedValue,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_dataUploadedByItem]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        this.setState({ filesDisplay: responseJson.result })
                        break;
                    default: this.setState({ filesDisplay: [] })

                }
            })
    }

    handleChangeFilter = (value, fieldName) => {
        let filterList = this.state.filterList.slice()
        switch (fieldName) {
            case 'iBrand1':
                filterList[3].value = ''
                filterList[4].value = ''
                filterList[3].option = [];
                filterList[4].option = [];
                this.get_Ibrand2Filter(value)
                break;
            case 'iBrand2':
                filterList[4].option = [];
                filterList[4].value = '';
                this.get_Ibrand3Filter(value)
                break;
            case 'itemG1':
                filterList[6].option = [];
                filterList[6].value = '';
                this.get_G3Filter(value)
                break;
        }
        filterList.map((val, i) => {
            if (val.name === fieldName) {
                val.value = value
            }
        })
        this.setState({ filterList: filterList })
    }

    handleSearchSubmit = () => {
        this.setState({ itemId: this.state.filterList })
        let obj = {}
        let isSelectedOnce = false
        this.state.filterList.map((val, i) => {
            obj[`${val.name}`] = val.value;
            if (val.value !== '') {
                isSelectedOnce = true
            }
        })
        if (isSelectedOnce) {
            this.get_productData(obj)
        } else {
            alert('กรุณาเลือกอย่างน้อย 1 ตัวเลือก')
        }
    }

    render() {
        const { productData, filterList } = this.state;

        return (
            <React.Fragment>
                <Navbar nav={'Flim'} menu={'Film_DisplayTableProductImage'} />
                <div style={{ padding: '10px' }}>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader style={{ backgroundColor: 'unset', color: 'black' }}><i class="fa fa-info-circle fa-lg" aria-hidden="true"></i> ข้อมูลสินค้า</CardHeader>
                        <CardBody>
                            <div style={{ padding: '10px' }}>
                                <Row>
                                    {
                                        filterList.map((val, i) => {
                                            return (
                                                <Col xs="12" sm="12" md="6" style={{ padding: '5px' }}>
                                                    <Row>
                                                        <Col xs="12" sm="6" md="3" >{val.displayName}:</Col>
                                                        {
                                                            val.inputType === 'option' ?
                                                                <Col xs="12" sm="6" md="9" >
                                                                    <Select
                                                                        defaultValue={val.value}
                                                                        value={val.option.filter(option => option.value === val.value)}
                                                                        onChange={(e) => this.handleChangeFilter(e.value, val.name)}
                                                                        options={val.option}
                                                                        placeholder={'ค้นหา ' + val.displayName}
                                                                    />
                                                                </Col>
                                                                : <Col xs="12" sm="6" md="9" >
                                                                    <Input placeholder={val.displayName} onChange={(e) => this.handleChangeFilter(e.target.value, val.name)} />
                                                                </Col>
                                                        }
                                                    </Row>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                                <Row>
                                    <Col sm="12" md="12" style={{ padding: '20px 5px 5px 5px' }}>
                                        <div style={{ textAlign: 'end' }}>
                                            <div><Button color="primary" onClick={() => this.handleSearchSubmit()} ><i class="fa fa-search" aria-hidden="true"></i> Search</Button></div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                    <Card style={{ margin: '10px' }}>
                        <CardBody>
                            <BootstrapTable style={{ display: 'block !important' }} wrapperClasses="table-responsive" keyField='id' data={productData} columns={columns} pagination={paginationFactory()} />
                        </CardBody>
                    </Card>
                </div>
            </React.Fragment>
        );
    }
}

export default Film_DisplayTableProductImage;